import selectOption from '@/store/dict/selectOptionDict'

export default function () {
  const maintenanceState = {
    '-1': '已取消',
    1: '待使用',
    2: '维修中',
    3: '已完成',
    '-2': '退款中',
  }
  const auditState = {
    11: '维修中｜待审核',
    12: '维修中|已通过',
    13: '维修中|已驳回',
    21: '维修完成|待审核',
    22: '维修完成|已通过',
    23: '维修完成|已驳回',
  }

  const payState = {
    0: '待支付',
    1: '已支付',
    '-1': '支付失败',
  }

  const refundState = {
    0: '退款中',
    1: '退款完成',
    '-1': '退款取消',
  }
  const settlementState = {
    1: '未结算',
    2: '已结算',
  }
  const sourceTypeEnum = {
    SYSTEM_INPUT: 0, // 系统录入
    REPAIR_SHOP: 1, // 维修厂
    PERSONAL_CONSUMPTION: 2, // 个人消费
  }
  const sourceType = {
    [sourceTypeEnum.SYSTEM_INPUT]: '系统录入',
    [sourceTypeEnum.REPAIR_SHOP]: '维修厂',
    [sourceTypeEnum.PERSONAL_CONSUMPTION]: '个人消费',
  }
  const tableColums = [
    {
      name: 'id',
      columnProps: {
        prop: 'id',
        label: '维保单ID',
        width: 200,
      },
      type: 'manual',
    },
    {
      name: 'plateNo',
      columnProps: {
        prop: 'plateNo',
        label: '车牌号',
        width: 100,
      },
      showColumnItem: !this.isCarDetail,
    },
    {
      name: 'type',
      columnProps: {
        prop: 'type',
        label: '维保类型', // 维保类型(MaintenanceTypeEnum 1维修2保养4事故)
      },
      getText: ({ row }) => selectOption.maintenanceTypeDict[row.type],
    },
    {
      name: 'incomeTime',
      columnProps: {
        prop: 'incomeTime',
        label: '送厂时间',
      },
    },
    {
      name: 'totalAmount',
      columnProps: {
        prop: 'totalAmount',
        label: '维保费用',
      },
    },
    {
      name: 'expenseBearingPartyValue',
      columnProps: {
        prop: 'expenseBearingPartyValue',
        label: '费用承担方',
        width: 120,
      },
    },
    {
      name: 'providerName',
      columnProps: {
        prop: 'providerName',
        label: '服务商名称',
        width: 200,
      },
    },
    {
      name: 'storeName',
      columnProps: {
        prop: 'storeName',
        label: '维修厂名称',
        width: 200,
      },
    },
    {
      name: 'maintenanceState',
      columnProps: {
        prop: 'maintenanceState', // 维保状态(MaintenanceOrderStateEnum -1已取消1待使用2维修中3已完成-2退款中)
        label: '维保状态',
      },
      getText: ({ row }) => maintenanceState[row.maintenanceState],
    },
    {
      name: 'payState',
      columnProps: {
        prop: 'payState',
        label: '支付状态', // 支付状态(MaintenanceOrderPayStateEnum 0待支付1已支付-1支付失败)
      },
      getText: ({ row }) => payState[row.payState],
    },
    {
      name: 'refundState',
      columnProps: {
        prop: 'refundState',
        label: '退款状态', // 退款状态(MaintenanceOrderRefundStateEnum 0退款中1退款完成-1退款取消)
      },
      getText: ({ row }) => refundState[row.refundState],
    },
    {
      name: 'orderId',
      columnProps: {
        prop: 'orderId',
        label: '租赁订单ID',
        width: 200,
      },
    },
    {
      name: 'thirdId',
      columnProps: {
        prop: 'thirdId',
        label: '三方订单ID',
        width: 200,
      },
    },
    {
      name: 'customerId',
      columnProps: {
        prop: 'customerId',
        label: '司机ID',
        width: 200,
      },
    },
    {
      name: 'customerName',
      columnProps: {
        prop: 'customerName',
        label: '司机名称',
      },
    },
    {
      name: 'brandName',
      columnProps: {
        prop: 'brandName',
        label: '品牌',
      },
    },
    {
      name: 'seriesName',
      columnProps: {
        prop: 'seriesName',
        label: '车系',
      },
    },
    {
      name: 'modelName',
      columnProps: {
        prop: 'modelName',
        label: '车型',
      },
    },
    {
      name: 'vin',
      columnProps: {
        prop: 'vin',
        label: 'VIN',
        width: 200,
      },
    },
    {
      name: 'rentPlanId',
      columnProps: {
        prop: 'rentPlanId',
        label: '租赁方案ID',
        width: 200,
      },
    },
    {
      name: 'rentPlanName',
      columnProps: {
        prop: 'rentPlanName',
        label: '租赁方案名称',
        width: 200,
      },
    },
    {
      name: 'collaborationId',
      columnProps: {
        prop: 'collaborationId',
        label: '合作关系ID',
        width: 200,
      },
    },
    {
      name: 'providerId',
      columnProps: {
        prop: 'providerId',
        label: '服务商ID',
        width: 200,
      },
    },
    {
      name: 'itemId',
      columnProps: {
        prop: 'itemId',
        label: '项目ID',
        width: 200,
      },
    },
    {
      name: 'itemName',
      columnProps: {
        prop: 'itemName',
        label: '项目名称',
        width: 200,
      },
    },
    {
      name: 'cityName',
      columnProps: {
        prop: 'cityName',
        label: '使用城市',
      },
    },
    {
      name: 'sourceType',
      columnProps: {
        prop: 'sourceType',
        label: '来源类型', // 来源类型(MaintenanceSourceTypeEnum 0系统录入1维修厂2个人消费)
      },
      getText: ({ row }) => sourceType[row.sourceType],
    },
    {
      name: 'auditState',
      columnProps: {
        prop: 'auditState', // 审核状态(MaintenanceOrderAuditStateEnum 11维修中|待审核12维修中|已通过13维修中|已驳回21维修完成|待审核22维修完成|已通过23维修完成|已驳回)
        label: '审核状态',
      },
      getText: ({ row }) => auditState[row.auditState],
    },
    {
      name: 'settlementState',
      columnProps: {
        prop: 'settlementState',
        label: '结算状态', // 结算状态(MaintenanceSettlementEnum 1未结算2已结算)
      },
      getText: ({ row }) => settlementState[row.settlementState],
    },
    {
      name: 'operate',
      columnProps: {
        prop: 'operate',
        label: '操作',
        fixed: 'right',
        width: 140,
      },
      type: 'operate',
      getOperateList: ({ row }) => {
        const operateList = []
        operateList.push({
          name: 'detail', label: '订单详情', action: () => this.jumpDetail(row),
        })

        if (this.judgePermission('vehicle_maintenance_list_edit_new') && row.sourceType === 0) {
          operateList.push({
            name: 'edit', label: '编辑', action: () => this.JumpEdit(row),
          })
        }

        if (row.receivableState === 0) {
          operateList.push({
            name: 'detail', label: '维保信息确认', action: () => this.openinfoDialog(row, 1),
          })
        }

        // 订单状态=待使用 审核状态=维修中｜已通过 支付状态=支付失败
        if (row.payState === -1) {
          operateList.push({
            name: 'detail', label: '发起支付', action: () => this.openinfoDialog(row, 2),
          })
        }
        // 有删除按钮权限并且来源为系统录入（sourceType=0)才允许删除
        if (this.judgePermission('vehicle_maintenance_list_delete') &&
          row.sourceType === sourceTypeEnum.SYSTEM_INPUT) {
          operateList.push({
            name: 'delete', label: '删除', action: () => this.deleteOrder(row),
          })
        }
        return operateList
      },
    },
  ]
  return {
    tableColums,
  }
}
